// Hardcoded end timestamp for the summer-2026 Forest Plus promo event.
// Source of truth for both the countdown target and the device-clock guard.
// Use UTC.

export const EVENT_END_MS = new Date('2026-09-16T08:00:00Z').getTime()
